"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Header = styled_components_1.default.h3 `
  font-family: CatV, sans-serif;
`;
const Container = styled_components_1.default.div `
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 8px;
  margin: 8px;
  background-color: white;
  border: 1px black solid;
  min-width: 150px;
`;
const List = styled_components_1.default.ul `
  list-style: none;
  padding-left: 0;
`;
const ActionButton = styled_components_1.default.div `
  outline: none;
  border: 1px solid black;
  margin: 16px;
  padding: 8px;
  font-family: CatV, monospace;
  color: black;
  cursor: pointer;

  &.active {
    color: white;
    background-color: black;
  }

  &:hover {
    color: #fa00dd;
  }
`;
const ChannelPeersList = ({ channel, players, muted, onMuteToggle }) => {
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Header, null, channel),
        react_1.default.createElement("div", null,
            react_1.default.createElement(ActionButton, { className: muted ? "active" : "", onClick: (e) => {
                    e.preventDefault();
                    onMuteToggle();
                } }, muted ? "Unmute" : "Mute")),
        react_1.default.createElement(List, null,
            players.map((p) => (react_1.default.createElement("li", { key: p.username },
                p.username,
                " ",
                p.speaking && "[SPEAKING]"))),
            players.length === 0 && react_1.default.createElement("p", null, "Empty channel"))));
};
exports.default = ChannelPeersList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hhbm5lbFBlZXJzTGlzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jbGllbnQvQ2hhbm5lbFBlZXJzTGlzdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxrREFBaUQ7QUFDakQsMEVBQXVDO0FBR3ZDLE1BQU0sTUFBTSxHQUFHLDJCQUFNLENBQUMsRUFBRSxDQUFBOztDQUV2QixDQUFDO0FBRUYsTUFBTSxTQUFTLEdBQUcsMkJBQU0sQ0FBQyxHQUFHLENBQUE7Ozs7Ozs7OztDQVMzQixDQUFDO0FBRUYsTUFBTSxJQUFJLEdBQUcsMkJBQU0sQ0FBQyxFQUFFLENBQUE7OztDQUdyQixDQUFDO0FBRUYsTUFBTSxZQUFZLEdBQUcsMkJBQU0sQ0FBQyxHQUFHLENBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBaUI5QixDQUFDO0FBU0YsTUFBTSxnQkFBZ0IsR0FBNkIsQ0FBQyxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLFlBQVksRUFBUyxFQUFFLEVBQUU7SUFDdEcsT0FBTyxDQUNMLDhCQUFDLFNBQVM7UUFDUiw4QkFBQyxNQUFNLFFBQUUsT0FBTyxDQUFVO1FBQzFCO1lBQ0UsOEJBQUMsWUFBWSxJQUNYLFNBQVMsRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRSxFQUNoQyxPQUFPLEVBQUUsQ0FBQyxDQUFDLEVBQUUsRUFBRTtvQkFDYixDQUFDLENBQUMsY0FBYyxFQUFFLENBQUM7b0JBQ25CLFlBQVksRUFBRSxDQUFDO2dCQUNqQixDQUFDLElBRUEsS0FBSyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FDYixDQUNYO1FBQ04sOEJBQUMsSUFBSTtZQUNGLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQ2xCLHNDQUFJLEdBQUcsRUFBRSxDQUFDLENBQUMsUUFBUTtnQkFDaEIsQ0FBQyxDQUFDLFFBQVE7O2dCQUFHLENBQUMsQ0FBQyxRQUFRLElBQUksWUFBWSxDQUNyQyxDQUNOLENBQUM7WUFDRCxPQUFPLENBQUMsTUFBTSxLQUFLLENBQUMsSUFBSSx5REFBb0IsQ0FDeEMsQ0FDRyxDQUNiLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixrQkFBZSxnQkFBZ0IsQ0FBQyJ9